import { render, staticRenderFns } from "./TeamDeptReview.vue?vue&type=template&id=217c7900&scoped=true"
import script from "./TeamDeptReview.vue?vue&type=script&lang=js"
export * from "./TeamDeptReview.vue?vue&type=script&lang=js"
import style0 from "./TeamDeptReview.vue?vue&type=style&index=0&id=217c7900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c7900",
  null
  
)

export default component.exports